import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-modal-salvar-alteracoes',
  templateUrl: './modal-salvar-alteracoes.component.html',
  styleUrls: ['./modal-salvar-alteracoes.component.scss']
})
export class ModalSalvarAlteracoesComponent {
  @Input() confirmFunc: Function;
  @Input() idGto: number;

  constructor(
    private readonly router: Router,
  ) { }

  public displayModal = false;

  public openDialog() {
    this.displayModal = true;
  }

  public closeDialog() {
    this.displayModal = false;
  }

  public goToDetalhe() {
    this.router.navigate(['detalhagto', this.idGto]);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gto-finalizar/modal-salvar-alteracoes/modal-salvar-alteracoes.component.ts